module.exports = __webpack_public_path__ + "img/clientD2BA3DCEDD5C4E13AE59A42318C7B47D-large.5c025781.jpg";